import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { HotelTopQuery } from "./query";

type Props = {
	hotelID: string;
};

export const useFetchHotelTop = ({ hotelID }: Props) => {
	return useCustomSuspenseQuery(HotelTopQuery, { variables: { hotelID } });
};
